import React from 'react';
import {
	SdfAvatar,
	SdfBadge,
	SdfBox,
	SdfCard,
	SdfQuickStat,
	SdfSpotIllustration
} from '@synerg/react-components';
import { CustomToolTip } from 'shared-one-ux-components';

const testInstance = (props = {}) => {
	let { testInstanceUsers, testInstanceUserConsentStatus, testOrganizationName, testOrganizationOID, consentorUsername } = props.projectDetails;

	// if (testInstanceUsers.length === 0) {
	//     testInstanceUsers = [
	//         {
	//             "name": "Ankit Shah",
	//             "userName": "AShah@ngc91"
	//         },
	//         {
	//             "name": "Cindy Melo",
	//             "userName": "CMelo@ngc91"
	//         }
	//     ];
	// }
	//
	// if (!consentorUsername) {
	//     consentorUsername = "CMelo@ngc91";
	//     testInstanceUserConsentStatus = "Yes";
	// }

	return (
		<div className="">
			<div className="text-heading-05 font-bold">Test instance</div>

			<div className='w-3/3 mt-4'>
				<SdfBox className='flex flex-row justify-around items-center capitalize' style={{height:'6.25rem'}}>
					<SdfQuickStat className='min-w-1/3' labelPosition='before' label='Test instance org name'>
						<CustomToolTip className='text-heading-05' text={testOrganizationName} startEllipsisLen={15} width='100%'/>
					</SdfQuickStat>

					<SdfQuickStat className='min-w-1/3' labelPosition='before' label='Test instance OOID'>
					 <div>
						 <CustomToolTip className='text-heading-05' text={testOrganizationOID} startEllipsisLen={15} width='100%'/>
					 </div>
					</SdfQuickStat>
					<SdfQuickStat className='min-w-1/3' labelPosition='before' label='Test instance Consented'>
						{testInstanceUserConsentStatus.toLowerCase() === 'no' && <div className='text-heading-05'>No</div>}
						{testInstanceUserConsentStatus.toLowerCase() === 'yes' && <div className='text-heading-05'>Yes</div>}
					</SdfQuickStat>
				</SdfBox>
			</div>

			<div className="text-heading-04 font-bold mt-4 mb-2">Users</div>

			{testInstanceUsers && Array.isArray(testInstanceUsers)
				&& testInstanceUsers.length > 0  && testInstanceUsers.map((user) => {
				function getUserInitials(name = 'N A'){
					return name.split(' ')[0][0].toUpperCase()
						+ name.split(' ')[1][0].toUpperCase();
				}

				return (
					<SdfCard className="flex flex-col h-[18rem] mb-4 rounded-2xl card-shadow">
						<div className="flex justify-between">
							<div className={"flex order-1 justify-start w-5/6"}>
								<div className="flex justify-between w-4/6">
									<div className='order-1 mr-4'>
										<SdfAvatar icon={''} initials={getUserInitials(user.name)} shape={"circle"} size={"lg"}/>
									</div>

									<div className='order-2 min-w-5/6'>
										<SdfQuickStat labelPosition='after' label={user.userName.split('@')[0] || 'NA'}>
											<div className='text-heading-05'>{user.name || 'NA'}</div>
										</SdfQuickStat>
									</div>

									{consentorUsername === user.userName &&
										<div className='order-3 min-w-3/4 max-w-3/4 flex justify-end items-center'>
											{testInstanceUserConsentStatus && testInstanceUserConsentStatus !== 'Yes' &&
												testInstanceUserConsentStatus !== 'No' &&
												<SdfBadge status='changed' className='flex-col'>
													<sdf-icon slot="graphic" icon="alert-warning"></sdf-icon>Pending consent
												</SdfBadge>}
											{testInstanceUserConsentStatus && testInstanceUserConsentStatus === 'Yes' &&
												<SdfBadge status='complete' className='flex-col'>
													<sdf-icon slot="graphic" icon="alert-success"></sdf-icon>Consented
												</SdfBadge>}
											{testInstanceUserConsentStatus && testInstanceUserConsentStatus === 'No' &&
												<SdfBadge status='failed' className='flex-col'>
													<sdf-icon slot="graphic" icon="alert-error"></sdf-icon>Declined consent
												</SdfBadge>}
										</div>
									}
								</div>
							</div>
						</div>
					</SdfCard>
				)
			})}

			{testInstanceUsers && testInstanceUsers.length === 0 &&
				<div className="flex-col mx-24 my-10 items-center sm:mt-16">
					<div className="flex flex-col items-center mx-24 my-10">
						<SdfSpotIllustration illustrationName="empty-clipboard" size="lg" />
						<div className="flex flex-col mt-4 text-center">
							<span className="text-2xl font-bold leading-xs tracking-xs" style={{ color: "#726c66" }}>
								{'No users found'}
							</span>
							<span className="text-body-02 grey-text mt-2">
								{'Partner has no test users yet!'}
							</span>
						</div>
					</div>
				</div>
			}
		</div>
	);
}

export default testInstance;
